import { render } from "./TabelDetail.vue?vue&type=template&id=70b339f7&scoped=true"
import script from "./TabelDetail.vue?vue&type=script&lang=js"
export * from "./TabelDetail.vue?vue&type=script&lang=js"

import "./TabelDetail.vue?vue&type=style&index=0&id=70b339f7&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b339f7"]])

export default __exports__